module.exports = require('./helpers/bundle-url').getBundleURL('dj12v') + "poh-image.0ff250c0.png";